(function(){
  var links = Array.prototype.slice.call(document.querySelectorAll('.toc a'));
  var secs = links.map(function(a){ return document.querySelector(a.getAttribute('href')); });
  if('IntersectionObserver' in window){
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting){ return; }
        var i = secs.indexOf(e.target);
        links.forEach(function(a, n){ a.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      });
    }, {rootMargin: '-96px 0px -70% 0px'});
    secs.forEach(function(s){ if(s){ obs.observe(s); } });
  }
  links[0].setAttribute('aria-current', 'true');
})();
